var map = {
	"./pureflo": "8EIe",
	"./pureflo.js": "8EIe",
	"./water": "w4hr",
	"./water-regional": "Oemf",
	"./water-regional.js": "Oemf",
	"./water.js": "w4hr"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "QqxZ";